export const modules = [
  "overview",
  "knowledge",
  "rag",
  "jobs",
  "history",
  "logs",
  "keys",
  "users",
  "codex",
  "skills",
  "sources",
  "settings",
] as const;

export type ModuleName = (typeof modules)[number];

export const currentModule = (): ModuleName => {
  const segments = window.location.pathname.split("/").filter(Boolean);
  const candidate = segments[0] === "console" ? segments[1] : undefined;
  if (candidate === "history") {
    history.replaceState({}, "", "/console/jobs#task-history");
    return "jobs";
  }

  return modules.includes(candidate as ModuleName)
    ? (candidate as ModuleName)
    : "overview";
};

export const isDocs = () => window.location.pathname.startsWith("/api-docs");

export function navigate(module: ModuleName, replace = false) {
  const nextPath = `/console/${module}`;

  if (window.location.pathname === nextPath) return;

  history[replace ? "replaceState" : "pushState"]({}, "", nextPath);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
